const Loader = () => {
  return <div className='loader animate-spin' />;
};

export default Loader;
